import './loader-global.css';
import cx from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { parseDOMString, removeElement } from '../../_utils';
import { SafeHTML } from '../../safe-html';
import { getLoaderTemplate } from './loader-global-template';
export const LoaderGlobal = ({ children, id, className, loadingText = '', inProgressLoadingMessages = [], loadingWaitTime = 30000, hideLoader = false, isTransparentBg = false, highOpacity = false, loadingTextClassName = '', isLoaderInOverlay = false, ...restProps }) => {
    const [loadingInfoText, setLoadingInfoText] = useState(loadingText);
    useEffect(() => {
        // No need to cycle through messages while the loader is hidden.
        if (hideLoader)
            return undefined;
        let count = 0;
        // If loading text is '' then take the first value from inProgressLoadingMessages
        if (loadingText === '' && inProgressLoadingMessages.length > 0) {
            setLoadingInfoText(inProgressLoadingMessages[0]);
            count = 1;
        }
        else {
            setLoadingInfoText(loadingText);
        }
        const timer = setInterval(() => {
            if (count < (inProgressLoadingMessages === null || inProgressLoadingMessages === void 0 ? void 0 : inProgressLoadingMessages.length)) {
                setLoadingInfoText(inProgressLoadingMessages[count]);
                count++;
            }
            else {
                clearInterval(timer);
            }
        }, loadingWaitTime);
        return () => clearInterval(timer);
    }, [inProgressLoadingMessages, loadingText, loadingWaitTime, hideLoader]);
    // Reference for the class is in loader-global.scss
    let opacityClass = highOpacity
        ? 'rdLoadingIndicatorHighOpacity'
        : 'rdLoadingIndicatorLowOpacity';
    if (isLoaderInOverlay) {
        opacityClass = 'rdLoadingIndicatorOverlay';
    }
    const loaderClassNames = cx('rdLoaderGlobalWrap', {
        rdHideLoader: hideLoader,
    }, className);
    // Memoize template to prevent recreation on every render
    const template = useMemo(() => getLoaderTemplate(opacityClass, loadingTextClassName), [opacityClass, loadingTextClassName]);
    // Memoize HTML string to prevent DOM recreation when text changes
    const loaderHtmlString = useMemo(() => {
        if (loadingInfoText) {
            return parseDOMString(template, '#data-loading-text', loadingInfoText);
        }
        return removeElement(template, '#data-loading-text');
    }, [template, loadingInfoText]);
    return (React.createElement("div", { id: id, className: loaderClassNames, "data-display-name": LoaderGlobal.displayName, ...restProps },
        React.createElement(SafeHTML, { html: loaderHtmlString, className: isTransparentBg ? 'rdOverrideStyle' : '' }),
        children));
};
LoaderGlobal.displayName = 'radiant_react_loading_indicator_global';
//# sourceMappingURL=loader-global.js.map